/*
function applyCustomerCheckoutRules() {
    const shoptetData = [...(window.dataLayer || [])]
        .reverse()
        .find((layer) => layer?.shoptet);
    const customerPriceListId = shoptetData?.shoptet?.customer?.priceListId;
    const withoutVat = Number(
        shoptetData?.shoptet?.cartInfo?.getNoBillingShippingPrice?.withoutVat
    );

    if (priceLists.includes(Number(customerPriceListId)) && $(".id--9").length && withoutVat < minHodnota) {
        $("#continue-order-button").addClass("hidden");
        if (!$('.next-step .checkout-error').length) {
            $(".next-step").append("<p class='checkout-error'>Minimální hodnota objednávky je " + minHodnota + " Kč bez DPH</p>");
        }
        $(".cart-header .step-2 a, .cart-header .step-3 a").each(function () {
            $(this).replaceWith($(this).contents());
        });
    }
}

$(applyCustomerCheckoutRules);
document.addEventListener("ShoptetDOMContentLoaded", applyCustomerCheckoutRules);
document.addEventListener("ShoptetDOMCartContentLoaded", applyCustomerCheckoutRules);




const shoptetCustomerData = [...(window.dataLayer || [])]
    .reverse()
    .find((layer) => layer?.shoptet);
const customerGroupId = Number(shoptetCustomerData?.shoptet?.customer?.groupId);

if (customerGroupId === 2) {
    $("body").addClass("velkoobchod");
} else {
    $("body").addClass("osobni");

}

*/


/*
if ($('body.osobni').length) {
    $('.price-additional').each(function () {
        const $this = $(this);
        $this.html($this.html().replace(/(&nbsp;|\s)*včetně DPH/i, ""));
    });
}
if ($('body.osobni.id--9').length) {
    $('.price-label.price-primary').text('Cena bez DPH:');
    $('.price-label.price-secondary').text('Celkem za zboží:');
}

if($('body.velkoobchod.id--16, body.velkoobchod.id--17').length) {
$('.price-label.price-secondary').text('Celkem bez DPH:');
}*/


if (Number(getShoptetDataLayer('customer').groupId) === 2) {
    $("body").addClass("velkoobchod");
} else {
    $("body").addClass("osobni");
}
